"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureErrors = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
exports.SignatureErrors = function (props) {
    var errorMessages = props.errorMessages;
    return errorMessages ? (react_1.default.createElement(core_1.Grid, { container: true, direction: "column", spacing: 1 }, errorMessages.map(function (error, index) {
        var title = error.title, message = error.message;
        return (react_1.default.createElement(core_1.Grid, { item: true, key: index },
            react_1.default.createElement(core_1.Typography, { component: "p", color: "error" },
                title && (react_1.default.createElement(core_1.Box, { fontWeight: "600", display: "inline", pr: 1 }, title + ": ")),
                message)));
    }))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
